var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayingSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 237, 0)",
    d: "M24.223,19.892 C23.712,20.429 22.863,20.450 22.326,19.939 C21.789,19.428 21.768,18.578 22.279,18.41 C24.756,15.449 24.756,11.366 22.279,8.774 C21.768,8.237 21.789,7.387 22.326,6.876 C22.863,6.365 23.712,6.386 24.223,6.923 C27.688,10.551 27.688,16.263 24.223,19.892 ZM17.438,26.826 L15.400,26.826 C14.586,26.825 13.817,26.455 13.308,25.820 L8.749,20.120 L2.688,20.120 C1.206,20.120 0.6,18.919 0.6,17.437 L0.6,9.391 C0.6,7.909 1.206,6.708 2.688,6.708 L8.749,6.708 L13.308,1.8 C13.817,0.373 14.586,0.3 15.400,0.2 L17.438,0.2 C18.919,0.2 20.120,1.203 20.120,2.685 L20.120,24.143 C20.120,25.625 18.919,26.826 17.438,26.826 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayingSound);
export default __webpack_public_path__ + "static/media/playingSound.2bb469ad.svg";
export { ForwardRef as ReactComponent };